import { Calendar, CheckCircle, CreditCard, FileText, Settings, User } from 'lucide-react';

export const REVIEW_STEPS = [
  { id: 0, label: 'Client', icon: User },
  { id: 1, label: 'Réservation', icon: Calendar },
  { id: 2, label: 'Options', icon: Settings },
  { id: 3, label: 'Financier', icon: CreditCard },
  { id: 4, label: 'Documents', icon: FileText },
  { id: 5, label: 'Validation', icon: CheckCircle },
] as const;

export type ReviewStepId = (typeof REVIEW_STEPS)[number]['id'];
